import { ITennisTourRanking } from "@sky-it-livedata/livedata-sports-design-system";
import { RankingData } from "../types";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { CreateRankingWidgetInputSchema } from "cdk/graphql";
import { isValidRanking } from "./typeguards";


export const transformQuery = (obj: RankingData): ITennisTourRanking => {
  if (isValidRanking(obj)) {
      CreateRankingWidgetInputSchema().parse(obj.data.getRankingWidget, {reportInput: true});
      const { rankings } = obj?.data?.getRankingWidget!;

      return {
        ranking: rankings?.map((item) => {
          return {
            position: item?.rank,
            flagUrl: item?.nationality,
            name: item?.playerName,
            score: Number(item?.points),
            trend: Number(item?.trend),
            id: item?.rank?.toString(),
      }}),
      } as ITennisTourRanking;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in RankingQuery object',
      data: obj
    });
  }
};
